import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { Divider } from 'primeng/divider';
import { Message } from 'primeng/message';

import { SlnkAbilityService } from '@app/auth/ability/ability.service';
import { CommonScopeValueRoleItemComponent } from '@app/common-modules/common-scope-value-used-in-roles-dialog/common-scope-value-role-item/common-scope-value-role-item.component';
import { ScopeValueUsedInRolesErrorItem } from '@app/common-modules/common-scope-value-used-in-roles-dialog/common-scope-value-used-in-roles-dialog.model';
import { AbilityActionEnum, AbilitySubjectEnum } from '@app/models/api/v1/auth/ability.model';

@Component({
  selector: 'slnk-common-scope-value-used-in-roles-dialog',
  templateUrl: './common-scope-value-used-in-roles-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Divider, Message, TranslatePipe, CommonScopeValueRoleItemComponent],
})
export class CommonScopeValueUsedInRolesDialogComponent {
  private readonly ability = inject(SlnkAbilityService);

  public readonly items = input.required<ScopeValueUsedInRolesErrorItem[]>();
  public readonly names = input<Record<string, string>>({});

  protected readonly canManageRoles = this.ability.can(AbilityActionEnum.MANAGE_ROLES, AbilitySubjectEnum.COMPANY_SETTINGS);

  protected readonly panels = computed(() =>
    this.items().map(item => ({
      value: item.uuid,
      label: this.names()[item.uuid] ?? item.name ?? '',
      roles: item.roles ?? [],
    })),
  );
}
